@if (headerTemplate) {
  <div class="d-flex align-items-center select-all">
    <div class="form-check ms-2" id="select-all-checkbox-container">
      <ng-container *ngTemplateOutlet="headerTemplate; context: {$implicit: offices}"/>
    </div>
  </div>
}
<hr class="my-2"/>
<div class="d-flex flex-row h-100">
  @if (offices.length === 0) {
    <span
      class="py-2 ps-2"
    >No result found</span>
  } @else {
    <cdk-virtual-scroll-viewport
      class="d-flex flex-row w-100"
      itemSize="32" minBufferPx="640"
      maxBufferPx="1240"
      >
      <div *cdkVirtualFor="let office of offices; let index = index; trackBy trackByFn; templateCacheSize: 0"
        class="d-flex flex-row py-2 ps-2 w-100 align-items-center form-check">
        <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: office}"/>
      </div>
    </cdk-virtual-scroll-viewport>
  }
</div>
